export default __webpack_public_path__ + "static/media/services_dev_web.46f156cd.svg";